import * as THREE from 'three'
import { MeshLine, MeshLineMaterial, MeshLineRaycast } from 'three.meshline'
import { LineSegmentsGeometry } from 'three/examples/jsm/lines/LineSegmentsGeometry.js'
import { LineSegments2 } from 'three/examples/jsm/lines/LineSegments2.js'
import { LineMaterial } from 'three//examples/jsm/lines/LineMaterial.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { VRMLoaderPlugin } from '@pixiv/three-vrm'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { WebIO } from '@gltf-transform/core'
import { DracoMeshCompression, MaterialsPBRSpecularGlossiness } from '@gltf-transform/extensions'
/* globals DracoEncoderModule */
/* globals DracoDecoderModule */
import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils'

export default {
  methods: {
    async loadGLTFwithDracoLoader ({ path, progressFunc, errorFunc }) {
      const loader = new GLTFLoader()
      const dracoLoader = new DRACOLoader()
      const decoderPath = 'https://www.gstatic.com/draco/versioned/decoders/1.4.1/'
      dracoLoader.setDecoderPath(decoderPath)
      loader.setDRACOLoader(dracoLoader)
      loader.register(parser => {
        return new VRMLoaderPlugin(parser)
      })

      const progress = progressFunc ? 
        progressFunc : (progress) => {
          const progressPercent = Math.floor(100.0 * (progress.loaded / progress.total))
          // console.log('progressPercent:', progressPercent)
        }
      const error = errorFunc ?
        errorFunc : (error) => {
          alert(error.type)
          console.error(error)
        }

      const gltf = await loader.loadAsync(path, progress, error)
      return gltf
    },
    async loadGLTFForVRM10 ({ path, progressFunc, errorFunc }) {
      const loader = new GLTFLoader()
      loader.register(parser => {
        return new VRMLoaderPlugin(parser)
      })
      const progress = progressFunc ? 
        progressFunc : (progress) => {
          const progressPercent = Math.floor(100.0 * (progress.loaded / progress.total))
          // console.log('progressPercent:', progressPercent)
        }
      const error = errorFunc ?
        errorFunc : (error) => {
          alert(error.type)
          console.error(error)
        }

      const gltf = await loader.loadAsync(path, progress, error)
      return gltf
    },
    createLineGeometoryToGroup ({ group, edgeDegreeThrehold=20 }) {
      let allMeshesInGroup = []
      const findTypeFromObject = (object, type) => {
        object.children.forEach((child) => {
          if (child.type === type) allMeshesInGroup.push(child)
          findTypeFromObject(child, type)
        })
      }
      findTypeFromObject(group, 'Mesh')

      const lineGroup = new THREE.Group()
      const lineMaterial = new THREE.LineBasicMaterial({ 
        // color: 0xff0000,
        color: 0x000000,
        // lineWidth: 2 // これは効かない
      })
      const meshlineMaterial = new MeshLineMaterial({ 
        color: 0x000000,
        lineWidth: 0.005
      })
      
      for (let i=0; i < allMeshesInGroup.length; i++) {
        const mesh = allMeshesInGroup[i]     
        const edges = new THREE.EdgesGeometry(mesh.geometry, 20)
        // const edges = new THREE.EdgesGeometry(mesh.geometry, edgeDegreeThrehold)
        edges.applyMatrix4(mesh.matrix)
        edges.applyQuaternion(mesh.quaternion)
        const wPos = mesh.getWorldPosition(new THREE.Vector3())
        const wScale = mesh.getWorldScale(new THREE.Vector3())
        const wQuaternion = mesh.getWorldQuaternion(new THREE.Quaternion())

        const line = new THREE.LineSegments(edges, lineMaterial)

        // 処理重め
        // const thickLineGeom = new LineSegmentsGeometry().fromEdgesGeometry(edges)
        // const line = new LineSegments2(thickLineGeom, new LineMaterial({ color: 0x000000, linewidth: 3 }))
        
        line.position.copy(wPos)
        line.scale.copy(wScale)
        line.quaternion.copy(wQuaternion)
        lineGroup.add(line)

        // const chilidLineGroup = new THREE.Group()
        // const points = edges.attributes.position.array
        // let newPoints = []
        // let counter = 0
        // for (let i = 0; i < points.length; i+=3) {
        //   newPoints.push(points[i], points[i + 1], points[i + 2])
        //   counter++
        //   if (counter === 2) {
        //     const line = new MeshLine()
        //     line.setPoints(newPoints)
        //     const lineMesh = new THREE.Mesh(line, meshlineMaterial)
        //     chilidLineGroup.add(lineMesh)
        //     newPoints = []
        //     counter = 0
        //   }
        // }
        // chilidLineGroup.position.copy(wPos)
        // chilidLineGroup.scale.copy(wScale)
        // chilidLineGroup.quaternion.copy(wQuaternion)
        // lineGroup.add(chilidLineGroup)

        // const points = edges.attributes.position.array
        // const line = new MeshLine()
        // line.setPoints(points)
        // const lineMesh = new THREE.Mesh(line, lineMaterial)
        // lineMesh.position.copy(wPos)
        // lineMesh.scale.copy(wScale)
        // lineMesh.quaternion.copy(wQuaternion)
        // lineGroup.add(lineMesh)
      }
      return lineGroup
    },
    async compressGLBtoDracoGLTF (blobGLB) {
      const io = new WebIO()
        .registerExtensions([DracoMeshCompression, MaterialsPBRSpecularGlossiness])
        .registerDependencies({
          'draco3d.encoder': await new DracoEncoderModule(),
          'draco3d.decoder': await new DracoDecoderModule()
        })
      
      // Load an uncompressed GLB file.
      // const document = await io.read('/gltf/sp.glb')
      const reader = new FileReader()
      reader.readAsArrayBuffer(blobGLB)
      await new Promise(resolve => reader.onload = () => resolve())
      const GLBArrayBuffuer = reader.result
      const GLBUint8Array = new Uint8Array(GLBArrayBuffuer)
      const document = await io.readBinary(GLBUint8Array)

      // Configure compression settings.
      document.createExtension(DracoMeshCompression)
        .setRequired(true)
        .setEncoderOptions({
          method: DracoMeshCompression.EncoderMethod.EDGEBREAKER,
          encodeSpeed: 5,
          decodeSpeed: 5
        })
      
      // Create compressed GLB, in an ArrayBuffer.
      const dracoArrayBuffer = await io.writeBinary(document) // ArrayBuffer
      const dracoBlob = new Blob([dracoArrayBuffer])
      const dracoGLTFBlobURL = URL.createObjectURL(dracoBlob)
      // const fileId = this.getUniqueStr()
      // const dracoFile = new File(
      //   [dracoBlob],
      //   `${fileId}.draco.gltf`,
      //   { type: 'application/octet-stream' }
      // )
      // console.log('dracoFile:', dracoFile)
      return dracoGLTFBlobURL
    },
    mergeObject (object) {
      object.updateMatrixWorld(true)

      const geometry = []
      object.traverse(c => {
        if (c.isMesh) {
          const g = c.geometry
          g.applyMatrix4( c.matrixWorld )
          for (const key in g.attributes) {
            if (key !== 'position' && key !== 'normal') {
              g.deleteAttribute(key)
            }
          }
          geometry.push( g.toNonIndexed() )
        }
      })

      const mergedGeometries = BufferGeometryUtils.mergeBufferGeometries(geometry, false)
      const mergedGeometry = BufferGeometryUtils.mergeVertices(mergedGeometries).center()
      
      // three^0.143.0からはこっちになる
      // const mergedGeometries = THREE.BufferGeometryUtils.mergeBufferGeometries(geometry, false)
      // const mergedGeometry = THREE.BufferGeometryUtils.mergeVertices(mergedGeometries).center()

      const group = new THREE.Group()
      const mesh = new THREE.Mesh(mergedGeometry)
      group.add(mesh)
      return group
    },
    mergeObjectByModelSize ({ object, emissiveColor=0x666666 }) {
      // MEMO: 今のシェーダーがメッシュの数によって負荷が上がるため
      // メッシュの数によってマージするオブジェクトを分ける
      let meshNum = 0
      // let verticesNum = 0
      object.traverse(node => {
        if (node.type === 'Mesh') {
          meshNum++
          // if (node.geometry.type === 'BufferGeometry') {
          //   verticesNum += node.geometry.index.count
          // }
        }
      })
      // console.log('meshNum:', meshNum)
      // console.log('verticesNum:', verticesNum)
      let result
      const maxMeshNum = 180
      // const maxMeshNum = 180 * 10000000000
      if (meshNum >= maxMeshNum) {
        console.log('mergeObject because of too many meshes')
        const mergedObject = this.mergeObject(object)
        // mergedObject.children[0].material = new THREE.MeshToonMaterial({color: 0x6699FF})
        const geometry = mergedObject.children[0].geometry
        const material = new THREE.MeshToonMaterial({
          color: 0x666666,
          emissive: emissiveColor
        })
        // const material = new THREE.MeshBasicMaterial({
        //   // color: 0xffffff,
        //   color: 0xff0000,
        //   emissive: emissiveColor
        // })

        result = new THREE.Mesh(geometry, material)

        // const innerMeshForLighting = new THREE.Mesh(geometry, material)
        // mergedObject.add(innerMeshForLighting)
        // result = mergedObject

        // 線画用と少し小さめのオブジェクト用とでわけてみる
        // const group = new THREE.Group()
        // let meshForOutline = new THREE.Mesh(geometry, material)
        // let smallMesh = meshForOutline.clone()

        // meshForOutline.applyOutline = true
        // meshForOutline.material.transparent = true
        // meshForOutline.material.opacity = 0.0
        // group.add(meshForOutline)

        // result = group
      } else {
        object.traverse(node => {
          if (node.type === 'Mesh') {
            if (node.geometry.type === 'BufferGeometry') {
              // scanデータのようなモデルの場合、これをしないとテクスチャが真っ暗になることがある
              if (node.geometry) node.geometry.computeVertexNormals()
              
              let materialParms = {
                color: node.material.color,
                // emissiveIntensity: 1,
                // この値で発色だいぶかわる
                emissive: emissiveColor
              }
              if (node.material.map) materialParms.map = node.material.map              
              const material = new THREE.MeshToonMaterial(materialParms)
              node.material = material

              // let materialParms = {
              //   color: node.material.color,
              //   emissive: 0x666666,
              //   roughness: node.material.roughness, // PBRプロパティを追加
              //   metalness: node.material.metalness,
              // }
              // if (node.material.map) materialParms.map = node.material.map
              
              // const material = new THREE.MeshToonMaterial(materialParms)
              // node.material = material
            }
          }
        })


        /* ChatGPTとシェーダーマテリアルを実験中
        const vertexShaderCode = `
          varying vec3 vNormal;
          varying vec4 vPosition;

          void main() {
            vNormal = normalize(normalMatrix * normal);
            vPosition = modelViewMatrix * vec4(position, 1.0);
            gl_Position = projectionMatrix * vPosition;
          }
        `
        const fragmentShaderCode = `
        varying vec3 vNormal;
        varying vec4 vPosition;

        void main() {
          // 法線の方向を用いたエッジ検出
          float edge = 1.0 - abs(dot(vNormal, vec3(0.0, 0.0, 1.0)));

          // 深度情報を用いたエッジ検出（オプション）
          float depth = gl_FragCoord.z;

          // 線の強度を調整
          float intensity = step(0.1, edge) * step(0.05, depth);

          // 線の色
          gl_FragColor = vec4(vec3(intensity), 1.0);
        }
        `
        function addEdgeEffectToModel(model) {
          model.traverse((child) => {
            if (child.isMesh && child.geometry.type === 'BufferGeometry') {
              // エッジ用のシェーダーマテリアルを作成
              const edgeShaderMaterial = new THREE.ShaderMaterial({
                vertexShader: vertexShaderCode,
                fragmentShader: fragmentShaderCode,
                uniforms: {
                  uTime: { value: 0.0 },
                },
                side: THREE.BackSide, // 裏面描画
              });
        
              // ジオメトリの中心を調整
              child.geometry.computeBoundingBox();
              const center = new THREE.Vector3();
              child.geometry.boundingBox.getCenter(center);
              child.geometry.translate(-center.x, -center.y, -center.z);
        
              // エッジメッシュを作成
              const edgeMesh = new THREE.Mesh(child.geometry.clone(), edgeShaderMaterial);
        
              // 元のスケールと位置を適用
              edgeMesh.position.copy(child.position);
              edgeMesh.rotation.copy(child.rotation);
              edgeMesh.scale.copy(child.scale).multiplyScalar(1.01); // 微調整で拡大
        
              // GLTFモデルのグループにエッジメッシュを追加
              model.add(edgeMesh);
            }
          });
        }
        addEdgeEffectToModel(object)
        */


        result = object
      }
      return result
    },
    updateMaterialEmissive ({ object, emissiveColor }) {
      object.traverse(node => {
        if (node.isMesh) {
          // let materialParms = { 
          //   color: node.material.color,
          //   emissive: emissiveColor
          // }
          // if (node.material.map) materialParms.map = node.material.map
          // const material = new THREE.MeshToonMaterial(materialParms)
          // node.material = material
          
          if (node.material && node.material.emissive) {
            let newMat = new THREE.MeshToonMaterial()
            newMat = newMat.copy(node.material)
            newMat.emissive = new THREE.Color(emissiveColor)
            node.material = newMat
          }
        }
      })
      return object
    }
  }
}